import React, { useState, useMemo } from 'react';
import "react-morphing-modal/dist/ReactMorphingModal.css";
import { Col, Row, Card, CardBody, CardHeader, Table, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import './styleCash.css';
import Select from 'react-select';
import { cedimi } from '../../constant/globalConstantsTypeClients';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiSelect } from "primereact/multiselect";


export const ModalReportCash = (
    { close, formatter, data, branchs, totalPageCount1, currentPage1, nextPage1, previousPage1, goToPage1, nextPage = null, previousPage = null, dataPaymets,
        dataCancell, dataDiscount, dataPatient, mostrar, mDateRange1, mDateRange2, handleInputChangeCash, loading, getReport, mSelectBranch,
        handleSelectValuesCash, branches, viewFormFilters, handleCloseViewTest, dataCredit, printCashClosing, totalPaymets, exportToExcel, dataMDiscount,
        handleClean, dataUser, ids_users, type_company, total_devolution, _active_micro, _url_helen, exportToExcelWithoutExams,
        urlHelen, insan, phersu,
        dataBonificacionCC,
        exportToExcelLabcen,
        labcen,
        exportToExcelWithoutExamsLabcen,
        ...props }) => {




    const [selectedPayMethods, setSelectedPayMethods] = useState([]);


    const paymentsFiltered = !loading
        ? dataPaymets.filter(
            p => p.amount !== 0 && p.id_pay_method !== 31
        )
        : [];




    const payMethodOptions = [
        {
            label: "Tarjeta de crédito",
            value: "creditCard"
        },
        {
            label: "Tarjeta de débito",
            value: "debitCard"
        },
        {
            label: "Efectivo",
            value: "cash"
        },
        {
            label: "Transferencia",
            value: "electronicTransfer"
        },
        {
            label: "Crédito",
            value: "credit"
        },
        {
            label: "Depósito",
            value: "deposit"
        }
    ];

    const filteredData = useMemo(() => {
        if (!Array.isArray(data)) {
            return [];
        }

        if (selectedPayMethods.length === 0) {
            return data;
        }

        return data.filter(row =>
            selectedPayMethods.some(method => Number(row[method] ?? 0) > 0)
        );
    }, [data, selectedPayMethods]);

    const payMethodNames = {
        creditCard: "TARJETA DE CRÉDITO",
        debitCard: "TARJETA DE DÉBITO",
        cash: "EFECTIVO",
        electronicTransfer: "TRANSFERENCIA ELECTRÓNICA DE FONDOS",
        credit: "CREDITO",
        deposit: "DEPÓSITO",
        bonificacion: "BONIFICACIÓN"
    };


    const paymentsToShow = useMemo(() => {
        if (!Array.isArray(paymentsFiltered)) {
            return [];
        }


        if (selectedPayMethods.length === 0) {
            return paymentsFiltered;
        }

        const selectedNames = selectedPayMethods.map(
            method => payMethodNames[method]
        );

        return paymentsFiltered.filter(item =>
            selectedNames.some(
                name =>
                    item.pay_method?.trim().toUpperCase() ===
                    name?.trim().toUpperCase()
            )
        );
    }, [paymentsFiltered, selectedPayMethods]);






    //*CONFIGURATON FINANCE
    let _valid_Finance = localStorage.getItem('finance');
    let _finance2 = localStorage.getItem('finance_view');
    let _validationFinance = (_valid_Finance === "True" && _finance2 === "False") ? true : false

    const rowExpansionTemplate = (row) => {
        return (
            <div
                style={{
                    width: "100%",
                    background: "#f8fafc",
                    padding: "16px 24px",
                    boxSizing: "border-box"
                }}
            >
                <Col sm="8">
                    <Row>
                        <div className="col-2">
                            <b style={{ fontSize: "11px" }} className="text-danger d-block">Tipo de Descuento</b>
                            {
                                row?.name_Preloaded_discount !== "" ? (row?.name_Preloaded_discount) : row?.nameCommont !== "" ? (row?.nameCommont) : "N/A"
                            }
                        </div>

                        <div className="col-2">
                            <b style={{ fontSize: "11px" }} className="text-danger d-block">Porcentaje de descuento</b>
                            {
                                row?.name_Preloaded_discount
                                    ? `${row?.percentagePreloaded_discount ?? 0}%`
                                    : row?.nameCommont
                                        ? `${row?.amountPercentag ?? 0}%`
                                        : "N/A"
                            }
                        </div>

                        <div className="col-2">
                            <b style={{ fontSize: "11px" }} className="text-danger d-block">Descuento aplicado</b>
                            {
                                row?.name_Preloaded_discount !== ""
                                    ? formatter.format(row?.amountDiscount ?? 0)
                                    : row?.nameCommont !== ""
                                        ? formatter.format(row?.amountDiscount ?? 0)
                                        : "N/A"
                            }
                        </div>
                        <div className="col-2">
                            <b style={{ fontSize: "11px" }} className="text-primary d-block">Usuario / S.R</b>
                            <label className='branches-label f-12'>{row?.ajuste ? (row?.nameUserAdjust + " " + row?.fech_Adjust) : "N/A"}</label>
                        </div>
                    </Row>
                </Col>
            </div>
        );
    };




    const [expandedRows, setExpandedRows] = useState(null);

    // * STYLES DATA TABLE
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };




    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/laboratory-External/cash-money.svg")} style={{ width: "60px", height: "60px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                        Reporte Global
                                    </h4>
                                    <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Análisis detallado de movimientos realizados al dia.
                                    </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>
                {
                    // * INFORMATION
                }
                <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "110%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                    <Col sm="12" className='pt-3'>
                        <Row>
                            <Col sm="2" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
                                <Card style={{
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    border: 'none',
                                    height: '100%',
                                    borderRadius: '12px'
                                }}>
                                    <CardHeader style={{
                                        background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                        color: 'white',
                                        padding: '15px',
                                        borderRadius: '12px 12px 0 0'
                                    }}>
                                        <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                            <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                        </h6>
                                    </CardHeader>
                                    <CardBody style={{ padding: '20px' }}>
                                        <Form onSubmit={(e) => getReport(e, true)}>
                                            <FormGroup>
                                                <div className="payment-title">
                                                    <div className="payment-title-icon">
                                                        <i className="fa fa-calendar"></i>
                                                    </div>

                                                    <span className="payment-title-text">
                                                        Fecha de inicio
                                                    </span>
                                                </div>

                                                <Input
                                                    type='date'
                                                    value={mDateRange1}
                                                    name='mDateRange1'
                                                    onChange={handleInputChangeCash}
                                                    className='form-control'
                                                    style={{
                                                        borderRadius: '8px',
                                                        border: '1px solid #ddd',
                                                        padding: '10px',
                                                        fontSize: '13px'
                                                    }}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <div className="payment-title">
                                                    <div className="payment-title-icon">
                                                        <i className="fa fa-calendar"></i>
                                                    </div>

                                                    <span className="payment-title-text">
                                                        Fecha de cierre
                                                    </span>
                                                </div>

                                                <Input
                                                    type='date'
                                                    value={mDateRange2}
                                                    name="mDateRange2"
                                                    onChange={handleInputChangeCash}
                                                    className='form-control'
                                                    style={{
                                                        borderRadius: '8px',
                                                        border: '1px solid #ddd',
                                                        padding: '10px',
                                                        fontSize: '13px'
                                                    }}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <div className="payment-title">
                                                    <div className="payment-title-icon">
                                                        <i className="fa fa-map-marker"></i>
                                                    </div>

                                                    <span className="payment-title-text">
                                                        Sucursal
                                                    </span>
                                                </div>

                                                <Select
                                                    name="mSelectBranch"
                                                    isClearable={true}
                                                    placeholder="Selecciona una sucursal"
                                                    options={branches}
                                                    onChange={(e) => handleSelectValuesCash(e, 'mSelectBranch')}
                                                    value={mSelectBranch}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: base => ({
                                                            ...base,
                                                            zIndex: 999999
                                                        }),
                                                        control: base => ({
                                                            ...base,
                                                            borderRadius: "8px",
                                                            border: "1px solid #ddd",
                                                            minHeight: "42px",
                                                            boxShadow: "none"
                                                        }),
                                                        placeholder: base => ({
                                                            ...base,
                                                            fontSize: "13px"
                                                        })
                                                    }}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <div className="payment-title">
                                                    <div className="payment-title-icon">
                                                        <i className="fa fa-building"></i>
                                                    </div>

                                                    <span className="payment-title-text">
                                                        Tipo de ingreso
                                                    </span>
                                                </div>

                                                <Select
                                                    name="type_company"
                                                    isClearable={true}
                                                    placeholder="Selecciona un tipo"
                                                    options={[
                                                        { "value": 1, "label": "Particular" },
                                                        { "value": 2, "label": "Empresas" }
                                                    ]}
                                                    onChange={(e) => handleSelectValuesCash(e, 'type_company')}
                                                    value={type_company}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: base => ({
                                                            ...base,
                                                            zIndex: 999999
                                                        }),
                                                        control: base => ({
                                                            ...base,
                                                            borderRadius: "8px",
                                                            border: "1px solid #ddd",
                                                            minHeight: "42px",
                                                            boxShadow: "none"
                                                        }),
                                                        placeholder: base => ({
                                                            ...base,
                                                            fontSize: "13px"
                                                        })
                                                    }}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <div className="payment-title">
                                                    <div className="payment-title-icon">
                                                        <i className="fa fa-users"></i>
                                                    </div>

                                                    <span className="payment-title-text">
                                                        Usuarios
                                                    </span>
                                                </div>

                                                <Select
                                                    name="ids_users"
                                                    isClearable={true}
                                                    placeholder="Selecciona un usuario"
                                                    options={dataUser}
                                                    onChange={(e) => handleSelectValuesCash(e, 'ids_users')}
                                                    value={ids_users}
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: base => ({
                                                            ...base,
                                                            zIndex: 999999
                                                        }),
                                                        control: base => ({
                                                            ...base,
                                                            borderRadius: "8px",
                                                            border: "1px solid #ddd",
                                                            minHeight: "42px",
                                                            boxShadow: "none"
                                                        }),
                                                        placeholder: base => ({
                                                            ...base,
                                                            fontSize: "13px"
                                                        })
                                                    }}
                                                />
                                            </FormGroup>

                                            <FormGroup className={(urlHelen === insan || urlHelen === phersu) ? "" : "d-none"}  >
                                                <Label className='f-w-600' style={{ fontSize: '12px', marginBottom: '10px', color: '#333' }}>


                                                    <div className="payment-title">
                                                        <div className="payment-title-icon">
                                                            <i className="fa fa-credit-card"></i>
                                                        </div>

                                                        <span className="payment-title-text">
                                                            Métodos de pago
                                                        </span>
                                                    </div>

                                                </Label>

                                                <MultiSelect
                                                    value={selectedPayMethods ?? []}
                                                    options={payMethodOptions}
                                                    onChange={(e) => {
                                                        setSelectedPayMethods(Array.isArray(e.value) ? e.value : []);
                                                    }}
                                                    optionLabel="label"
                                                    optionValue="value"
                                                    placeholder="Todos los métodos"
                                                    display="chip"
                                                    filter
                                                    showClear
                                                    maxSelectedLabels={2}
                                                    selectedItemsLabel="{0} métodos seleccionados"
                                                    style={{
                                                        width: "320px",
                                                        fontSize: "12px"
                                                    }}
                                                />
                                            </FormGroup>

                                            <Button
                                                type="submit"
                                                color="primary"
                                                block
                                                outline
                                                className="mb-3"
                                                disabled={loading}
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    borderWidth: '2px'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                {loading ? (
                                                    <>
                                                        <i className='pi pi-spin pi-spinner mr-2'></i>Buscando...
                                                    </>
                                                ) : (
                                                    <>
                                                        Buscar
                                                    </>
                                                )}
                                            </Button>
                                            <Button
                                                onClick={handleClean}
                                                outline
                                                color="danger"
                                                block
                                                disabled={loading}
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    borderWidth: '2px'
                                                }}
                                            >
                                                Limpiar
                                            </Button>
                                        </Form>
                                        <br />
                                        <label className='f-w-600' >Acciones</label>
                                        <div className="d-flex flex-column " style={{ gap: "10px" }}>
                                            <Button
                                                color="danger"
                                                onClick={printCashClosing}
                                                disabled={loading}
                                                block
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '6px',
                                                    fontSize: '13px',
                                                    fontWeight: 600,
                                                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                    transition: 'all 0.3s'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                                title="Exportar a PDF"
                                            >
                                                PDF
                                            </Button>
                                            {
                                                urlHelen !== labcen && <Button
                                                    color="success"
                                                    onClick={() => exportToExcel(filteredData)}
                                                    disabled={loading}
                                                    block
                                                    style={{
                                                        borderRadius: '10px',
                                                        padding: '6px',
                                                        fontSize: '13px',
                                                        fontWeight: 600,
                                                        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                        transition: 'all 0.3s'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                                    title="Exportar con estudios"
                                                >
                                                    Detallado con estudios
                                                </Button>

                                            }
                                            {
                                                urlHelen === labcen && <Button
                                                    color="success"
                                                    onClick={() => exportToExcelLabcen(filteredData)}
                                                    disabled={loading}
                                                    block
                                                    style={{
                                                        borderRadius: '10px',
                                                        padding: '6px',
                                                        fontSize: '13px',
                                                        fontWeight: 600,
                                                        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                        transition: 'all 0.3s'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                                    title="Exportar con estudios"
                                                >
                                                    Detallado con estudios
                                                </Button>

                                            }

                                            {
                                                urlHelen !== labcen && <Button
                                                    color="success"
                                                    onClick={() => exportToExcelWithoutExams(filteredData)}
                                                    disabled={loading}
                                                    block
                                                    outline
                                                    style={{
                                                        borderRadius: '10px',
                                                        padding: '6px',
                                                        fontSize: '13px',
                                                        fontWeight: 600,
                                                        borderWidth: '2px',
                                                        transition: 'all 0.3s'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                                    title="Exportar sin estudios"
                                                >
                                                    Detallado sin estudios
                                                </Button>
                                            }

                                            {
                                                urlHelen === labcen && <Button
                                                    color="success"
                                                    onClick={() => exportToExcelWithoutExamsLabcen(filteredData)}
                                                    disabled={loading}
                                                    block
                                                    outline
                                                    style={{
                                                        borderRadius: '10px',
                                                        padding: '6px',
                                                        fontSize: '13px',
                                                        fontWeight: 600,
                                                        borderWidth: '2px',
                                                        transition: 'all 0.3s'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                                    title="Exportar sin estudios"
                                                >
                                                    Detallado sin estudios
                                                </Button>
                                            }





                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col sm="10">
                                {
                                    // * GLOBAL INDICATORS
                                }
                                <Col sm="12" className="p-l-0 p-r-0  pb-3 container-global-zoom">
                                    <Row className="g-3 align-items-stretch ">
                                        <Col sm="5">
                                            <Card style={{
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                                border: 'none',
                                                height: '100%',
                                                borderRadius: '12px',
                                                overflow: 'hidden'
                                            }}>
                                                <CardHeader style={{
                                                    background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                                    color: 'white',
                                                    padding: '15px 20px',
                                                    borderRadius: '12px 12px 0 0'
                                                }}>
                                                    <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '16px' }}>
                                                        Métodos de Pago
                                                    </h6>
                                                </CardHeader>


                                                <CardBody
                                                    style={{
                                                        padding: "10px 12px",
                                                        backgroundColor: "#f8f9fa"
                                                    }}
                                                >
                                                    <div className="d-flex flex-column gap-1">
                                                        {paymentsToShow.length > 0 ? (
                                                            paymentsToShow.map((item, index) => (
                                                                <div
                                                                    key={`${item.pay_method}-${index}`}
                                                                    className="d-flex justify-content-between align-items-center"
                                                                    style={{
                                                                        borderRadius: 6,
                                                                        padding: "6px 10px",
                                                                        lineHeight: "1.2"
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            fontSize: 12.5,
                                                                            fontWeight: 500,
                                                                            color: "#333",
                                                                            whiteSpace: "nowrap",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            maxWidth: "70%"
                                                                        }}
                                                                    >
                                                                        <i
                                                                            className="fa fa-circle mr-2"
                                                                            style={{
                                                                                fontSize: 5,
                                                                                color: "#28a745"
                                                                            }}
                                                                        />

                                                                        {item.pay_method}
                                                                    </span>

                                                                    <span
                                                                        style={{
                                                                            fontSize: 13,
                                                                            fontWeight: 600,
                                                                            whiteSpace: "nowrap"
                                                                        }}
                                                                    >
                                                                        {formatter.format(Number(item.amount) || 0)}
                                                                    </span>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div
                                                                style={{
                                                                    padding: "10px",
                                                                    textAlign: "center",
                                                                    fontSize: "12px",
                                                                    color: "#777"
                                                                }}
                                                            >
                                                                No existen montos para los métodos seleccionados.
                                                            </div>
                                                        )}
                                                    </div>
                                                </CardBody>



                                            </Card>
                                        </Col>
                                        <Col sm="4">
                                            <Card style={{
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                                border: 'none',
                                                height: '100%',
                                                borderRadius: '12px',
                                                overflow: 'hidden'
                                            }}>
                                                <CardHeader style={{
                                                    background: 'linear-gradient(135deg, #f59e0b 0%, #f59e0b 100%)',
                                                    color: 'white',
                                                    padding: '15px 20px',
                                                    borderRadius: '12px 12px 0 0'
                                                }}>
                                                    <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '16px' }}>
                                                        <i className="fa fa-exchange-alt mr-2"></i>Detalle de Movimientos
                                                    </h6>
                                                </CardHeader>
                                                <CardBody style={{ padding: '20px', backgroundColor: '#f8f9fa' }}>
                                                    <Table size="sm" borderless style={{ marginBottom: 0 }}>
                                                        <tbody>
                                                            <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
                                                                <td style={{ padding: '12px 8px', fontSize: '16px', color: '#333' }}>

                                                                    <strong>Cancelaciones</strong>
                                                                </td>
                                                                <td className="text-end" style={{ padding: '12px 8px' }}>
                                                                    <label style={{ fontSize: "16px" }} >
                                                                        {!loading && formatter.format(dataCancell ?? 0)}
                                                                    </label>

                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '12px 8px', fontSize: '16px', color: '#333' }}>
                                                                    <strong>Descuentos</strong>
                                                                </td>
                                                                <td className="text-end" style={{ padding: '12px 8px' }}>
                                                                    <label style={{ fontSize: "16px" }} > {!loading && formatter.format(dataMDiscount ?? 0)}</label>
                                                                </td>
                                                            </tr>
                                                            {
                                                                _url_helen === cedimi &&
                                                                _validationFinance && (
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                padding: '12px 8px',
                                                                                fontSize: '16px',
                                                                                color: '#333'
                                                                            }}
                                                                        >
                                                                            <strong>Control de calidad</strong>
                                                                        </td>

                                                                        <td
                                                                            className="text-end"
                                                                            style={{
                                                                                padding: '12px 8px'
                                                                            }}
                                                                        >
                                                                            <label
                                                                                style={{
                                                                                    fontSize: "16px"
                                                                                }}
                                                                            >
                                                                                {
                                                                                    !loading &&
                                                                                    formatter.format(
                                                                                        dataBonificacionCC ?? 0
                                                                                    )
                                                                                }
                                                                            </label>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }



                                                        </tbody>
                                                    </Table>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col sm="3">
                                            <Card style={{
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                border: 'none',
                                                height: '100%',
                                                background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                                                color: 'white',
                                                borderRadius: '12px',
                                                overflow: 'hidden'
                                            }}>
                                                <CardBody style={{ padding: '25px', textAlign: 'center' }}>
                                                    <div style={{
                                                        fontSize: '15px',
                                                        opacity: 0.9,
                                                        marginBottom: '15px',
                                                        fontWeight: 600,
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '1px'
                                                    }}>
                                                        <i className="fa fa-dollar-sign mr-2"></i>Total Global
                                                    </div>
                                                    <h3 className="mb-3" style={{
                                                        fontSize: '28px',
                                                        color: '#fff',
                                                        fontWeight: 800,
                                                        textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                    }}>
                                                        {formatter.format(totalPaymets ?? 0)}
                                                    </h3>
                                                    <div style={{
                                                        padding: '8px 12px',
                                                        background: 'rgba(255,255,255,0.15)',
                                                        borderRadius: '8px',
                                                        marginTop: '15px'
                                                    }}>
                                                        <small style={{
                                                            fontSize: '17px',
                                                            opacity: 0.95,
                                                            display: 'block'
                                                        }}>
                                                            <i className="fa fa-users mr-1"></i>
                                                            {!loading && `${data.length} pacientes`}
                                                        </small>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                                {
                                    // * DATATABLE 
                                }
                                <div style={{
                                    marginTop: '20px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    backgroundColor: '#fff'
                                }}>
                                    <DataTable
                                        value={filteredData}

                                        // value={data}
                                        loading={loading}
                                        scrollable
                                        scrollWidth="100%"
                                        dataKey="nim"
                                        expandedRows={expandedRows}
                                        onRowToggle={(e) => setExpandedRows(e.data)}
                                        rowExpansionTemplate={rowExpansionTemplate}
                                        paginator
                                        rows={8}
                                        rowsPerPageOptions={[8, 16, 24, 50]}
                                        className="data-table"
                                        stripedRows
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
                                        style={{
                                            fontSize: '12px'
                                        }}
                                        emptyMessage="No se encontraron registros"
                                    >
                                        <Column
                                            expander
                                            frozen
                                            style={{ width: '34px', minWidth: '34px', maxWidth: '34px' }}
                                            headerStyle={{ width: '34px' }}
                                        />

                                        <Column
                                            field="nim"
                                            header={
                                                _url_helen === cedimi
                                                    ? "Solicitud (NIM)"
                                                    : (_validationFinance ? "#" : "Solicitud (NIM)")
                                            }
                                            frozen
                                            body={(row, { rowIndex }) => (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: "8px",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    {_active_micro === "True" && (
                                                        <span
                                                            className={
                                                                row.is_micro
                                                                    ? "badge-detail-M"
                                                                    : "badge-detail-C"
                                                            }
                                                        >
                                                            {row.is_micro ? _url_helen === cedimi ? "H.H" : "S" : "C"}
                                                        </span>
                                                    )}

                                                    <span>
                                                        {_url_helen === cedimi
                                                            ? (row.nim ?? "--")
                                                            : (_validationFinance
                                                                ? rowIndex + 1
                                                                : (row.nim ?? "--"))}
                                                    </span>
                                                </div>
                                            )}
                                            style={{
                                                minWidth: "120px",
                                                fontSize: "11px",
                                                padding: "5px",
                                                textAlign: "center",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                            sortable
                                        />


                                        {/* <Column
                                            field="nim"
                                            header={
                                                _url_helen === cedimi
                                                    ? "Solicitud (NIM)"
                                                    : (_validationFinance ? "#" : "Solicitud (NIM)")
                                            }
                                            frozen
                                            body={(row, { rowIndex }) =>
                                                _url_helen === cedimi
                                                    ? (row.nim ?? "--")
                                                    : (_validationFinance ? rowIndex + 1 : row.nim ?? "--")
                                            }
                                            style={{
                                                minWidth: "120px",
                                                fontSize: "11px",
                                                padding: "5px",
                                                textAlign: "center",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                            sortable
                                        />
                                        {_active_micro === "True" && (
                                            <Column
                                                header="Tipo"
                                                frozen
                                                body={(row) => (
                                                    <span className={row.is_micro ? "badge-detail-M" : "badge-detail-C"}>
                                                        {row.is_micro ? "S" : "C"}
                                                    </span>
                                                )}
                                                style={{
                                                    minWidth: '100px', fontSize: "11px",
                                                    padding: "5px",
                                                    textAlign: "center",
                                                    fontFamily: "Montserrat, sans-serif",
                                                }}
                                                headerStyle={headerStyle}
                                            />
                                        )} */}
                                        <Column
                                            header="Paciente"
                                            frozen
                                            body={(row) => row.typeClientUser ?? "--"}
                                            style={{
                                                minWidth: '150px', fontSize: "11px",
                                                padding: "5px",
                                                textAlign: "center",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                            sortable
                                            field="typeClientUser"
                                        />
                                        <Column
                                            header="Sucursal"
                                            frozen
                                            body={(row) => row.name_branches ?? "--"}
                                            style={{
                                                minWidth: '150px', fontSize: "11px",
                                                padding: "5px",
                                                textAlign: "center",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                            sortable
                                            field="name_branches"
                                        />
                                        <Column
                                            frozen
                                            header="Usuario / Hora"
                                            body={(row) => (
                                                <div className="text-center">
                                                    <div>{row.user ?? "--"}</div>
                                                    <small><b>{row.hour ?? "--"}</b></small>
                                                </div>
                                            )}
                                            style={{
                                                minWidth: '160px', fontSize: "11px",
                                                padding: "5px",
                                                textAlign: "center",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                        />
                                        <Column
                                            header="Tipo de Ingreso"
                                            frozen
                                            bodyClassName="tipo-ingreso-td"
                                            body={(row) => (
                                                <div className="tipo-ingreso-cell">
                                                    <div className="tipo-ingreso-title">
                                                        {row.type === "Empresas" ? "Empresa" : "Público General"}
                                                    </div>

                                                    {row.type === "Empresas" && (
                                                        <div className="tipo-ingreso-sub">
                                                            {row.name_company ?? "--"}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            style={{ width: '150px' }}
                                            headerStyle={headerStyle}
                                            sortable
                                            field="type"

                                        />
                                        <Column
                                            header="Tarjeta Crédito"
                                            body={(row) => formatter.format(row.creditCard ?? 0)}
                                            style={{
                                                minWidth: '160px', textAlign: 'right', fontSize: "11px",
                                                padding: "5px",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                        />
                                        <Column
                                            header="Tarjeta Débito"
                                            body={(row) => formatter.format(row.debitCard ?? 0)}
                                            style={{
                                                minWidth: '160px', textAlign: 'right', fontSize: "11px",
                                                padding: "5px",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                        />
                                        <Column
                                            header="Efectivo"
                                            body={(row) => formatter.format(row.cash ?? 0)}
                                            style={{
                                                minWidth: '120px', textAlign: 'right', fontSize: "11px",
                                                padding: "5px",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                        />
                                        <Column
                                            header="Transferencia"
                                            body={(row) => formatter.format(row.electronicTransfer ?? 0)}
                                            style={{
                                                minWidth: '120px', textAlign: 'right', fontSize: "11px",
                                                padding: "5px",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                        />
                                        <Column
                                            header="Crédito"
                                            body={(row) => formatter.format(row.credit ?? 0)}
                                            style={{
                                                minWidth: '120px', textAlign: 'right', fontSize: "11px",
                                                padding: "5px",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                        />
                                        {
                                            _url_helen === cedimi && _validationFinance && (
                                                <Column
                                                    header="Control de calidad"
                                                    body={(row) => formatter.format(row.bonificacion ?? 0)}
                                                    style={{
                                                        minWidth: "130px",
                                                        textAlign: "right",
                                                        fontSize: "11px",
                                                        padding: "5px",
                                                        fontFamily: "Montserrat, sans-serif",
                                                    }}
                                                    headerStyle={headerStyle}
                                                />
                                            )
                                        }
                                        <Column
                                            header="Total"
                                            body={(row) => (
                                                <>
                                                    {row.ajuste && <b className="labelIndicadorCash"></b>}
                                                    {row.status === "Vigente" && (
                                                        <div>{formatter.format(row.amount ?? 0)}</div>
                                                    )}
                                                </>
                                            )}
                                            style={{
                                                minWidth: '130px', textAlign: 'right', fontSize: "11px",
                                                padding: "5px",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                        />
                                        {
                                            urlHelen === labcen && <Column
                                                header="Total S.R"
                                                body={(row) => row?.amount_is_adjust ?? 0}
                                                style={{
                                                    minWidth: '120px', fontSize: "11px",
                                                    padding: "5px",
                                                    textAlign: "center",
                                                    fontFamily: "Montserrat, sans-serif",
                                                }}
                                                headerStyle={headerStyle}
                                            />
                                        }

                                        <Column
                                            header="Fecha de Ingreso"
                                            body={(row) =>
                                                row.status === "Pendiente" ? "N/A" : row.fech_admision
                                            }
                                            style={{
                                                minWidth: '150px', fontSize: "11px",
                                                padding: "5px",
                                                textAlign: "center",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                            sortable
                                            field="fech_admision"
                                        />

                                        <Column
                                            header="Pago"
                                            body={(row) => row.is_fullPaid ?? "--"}
                                            style={{
                                                minWidth: '120px', fontSize: "11px",
                                                padding: "5px",
                                                textAlign: "center",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                        />
                                        <Column
                                            header="Orden"
                                            body={(row) => (
                                                <span
                                                    className={
                                                        row.status === "Vigente"
                                                            ? "badge-detail-status"
                                                            : "badge-detail-status2"
                                                    }
                                                >
                                                    {row.status}
                                                </span>
                                            )}
                                            style={{
                                                minWidth: '120px', fontSize: "11px",
                                                padding: "5px",
                                                textAlign: "center",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                            sortable
                                            field="status"

                                        />
                                        <Column
                                            header="Facturación"
                                            body={(row) => (
                                                <span
                                                    className={
                                                        row.is_invoice === "Facturado"
                                                            ? "badge-detail-Invoice2"
                                                            : "badge-detail-Invoice"
                                                    }
                                                >
                                                    {row.is_invoice}
                                                </span>
                                            )}
                                            style={{
                                                minWidth: '150px', textAlign: 'center', fontSize: "11px",
                                                padding: "5px",
                                                fontFamily: "Montserrat, sans-serif",
                                            }}
                                            headerStyle={headerStyle}
                                            sortable
                                            field="is_invoice"
                                        />
                                    </DataTable>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Card>
            </div>
        </div>
    )
}


